import { useState, useEffect, useCallback } from 'react';

import { useGetHistoryMonitoring } from 'hooks/Traps/useGetHistoryMonitoring';

interface UseDateRangeProps {
  slug: string;
  type: string;
}

export const useDateRange = ({ slug, type }: UseDateRangeProps) => {
  // Initialize startDate as one year before today's date, and endDate as today
  const today = new Date();
  const lastYear = new Date(today);
  lastYear.setFullYear(today.getFullYear() - 1);

  const [startDate, setStartDate] = useState<string>(lastYear.toISOString().split('T')[0]);
  const [endDate, setEndDate] = useState<string>(today.toISOString().split('T')[0]);

  const { data, refetch, isLoading, isRefetching } = useGetHistoryMonitoring(slug, type, startDate, endDate);

  const handlePeriodChange = useCallback(() => {
    const today = new Date();
    setEndDate(today.toISOString().split('T')[0]);
  }, []);

  useEffect(() => {
    if (startDate || endDate) {
      const timer = setTimeout(() => {
        refetch();
      }, 1000);

      return () => clearTimeout(timer);
    }
  }, [startDate, endDate, slug, refetch]);

  return {
    startDate,
    endDate,
    data,
    isLoading,
    isRefetching,
    refetch,
    handlePeriodChange,
    setStartDate,
    setEndDate,
  };
};
